import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'
import { Redirect, Link } from 'react-router-dom'

import { editPassword as sEditPassword } from './../../../store/actions/Session'
import { fetchReset } from './../../../services/ApiController'

import { Form, LinkButtonStyle } from './../../../styles'
import { Field, Button, User, Error, Load, Success } from './../../../components'

class EditPassword extends Component {
  state = {
    error: '',
    success: '',
    isLoaded: true,
    token: '',
    redirect: false,
    formdata: {},
  }

  componentDidMount() {
    this.getResetPassword()
    ReactGA.pageview('/reset-password');
  }

  getResetPassword = async () => {
    const token = this.getURLParameter(this.props.location,'token') 
    await fetchReset(`/reset-password.json?token=${token}`).then((data) =>{
     if (data.form) {
       this.setState({ form: data.form, isLoaded: false})
     } else {
      this.setState({ redirect: true })
     }
    }).catch((err) => {
      console.log(err)
    })
  }

  addFormData = (data) => {
    const { formData } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ formData: { ...formData, ...row} })
  }

  requestForgot = async () => {
    await this.props.changePassword(this.state.formData, this.state.form.action).then(() => {
      if (this.props.error && this.props.error !== '') this.setState({error: this.props.error})
      if (this.props.success && this.props.success !== '') {
        this.setState({success: 'Password changed'})
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  //utils
  getURLParameter(url, name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url.search) || [null, ''])[1].replace(/\+/g, '%20')) || null
  }

  render() {
    const { isLoaded, redirect, form, error, success } = this.state
    return(
      <div className='forgot-password'>
        {
          redirect && (
            <Redirect to="/" />
          )
        }
        {
          isLoaded && (
            <Load width={50} height={50} />
          )
        }
       {
         form && (
          <div>
            <form className={Form} onSubmit={this.requestForgot}>
              <Field type="password" onChange={this.addFormData}  id={`${form.fields.plainPassword.id}$first`} name={`${form.fields.plainPassword.name}[first]`} value='' >New Password </Field>
              <Field type="password" onChange={this.addFormData} id={`${form.fields.plainPassword.id}$second`} name={`${form.fields.plainPassword.name}[second]`} value='' >Confirm new Password </Field>
              <Field type="hidden" onChange={this.addFormData} id={form.fields['_token'].id} name={form.fields['_token'].name} value={form.fields['_token'].value} >Confirm new Password </Field>
              <Button type='submit' onCallback={this.requestForgot}> <User width="24" height="24" /> Reset password </Button>
            </form>
            <div className="forgot-password--bottom">
                <Link to="/login" className={LinkButtonStyle}><User width="24" height="24" /> Login page </Link>
            </div>
            {
              error !== '' && (
                <Error>{error}</Error>
              )
            }
            {
              success !== '' && (
                <Success>{success}</Success>
              )
            }
          </div>
         )
       }
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    error: Session.error && Session.error.changePassword,
    success: Session.passwordChanged
  }),
  dispatch => ({
    changePassword: (fields,action) => dispatch(sEditPassword(fields,action))
  })
)(EditPassword)


// WEBPACK FOOTER //
// ./src/scenes/Auth/Pages/EditPassword.js